import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import VueGtag from 'vue-gtag';

import { capitalize } from '@/assets/js/utility';
import { camelCase } from 'lodash';

import dayjs from '@/plugins/dayjs';
import vuetify from '@/plugins/vuetify';
import utility from '@/plugins/utility';
import variables from '@/plugins/variables';
import i18n from '@/plugins/i18n';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import 'video.js/dist/video-js.css';
import VuePapaParse from 'vue-papa-parse';
import '@/assets/fonts/style.css';

Vue.config.productionTip = false;

Vue.use(dayjs);
Vue.use(utility);
Vue.use(variables);
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
});
Vue.use(VuePapaParse);

const requireComponent = require.context(
  // The relative path of the components folder
  '@/components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = capitalize(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

/**
 * VNode renderer global component, mainly for use in Vuetify's autocompletes
 * https://github.com/vuetifyjs/vuetify/issues/16644#issuecomment-1458227547
 */
Vue.component('VNodeRenderer', {
  name: 'VNodeRenderer',
  functional: true,
  render: (h, ctx) => (typeof ctx.props.vnodes == 'string' ? [ctx.props.vnodes] : ctx.props.vnodes),
});

console.log(`Data aktualizacji: ${new Date(process.env.VUE_APP_DATE_BULID).toLocaleString()}`);
console.log(
  `Wersja front-endu: ${process.env.VUE_APP_FRONT_VERSION_DATE}, ${process.env.VUE_APP_FRONT_VERSION_NUMBER}`
);

// dodanie tłumaczeń do Vuetify na podstawie zmiennej z pliku .env (ogółem okropne, ale inaczej się nie dało)
(async () => {
  const locale = process.env.VUE_APP_I18N_LOCALE;
  const file = await import(/* webpackExclude: /\.map/ */ `vuetify/es5/locale/${locale}`);
  vuetify.preset.lang.locales[locale] = file.default;
})();

async function getSettingsGoogleAnalytics() {
  try {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/settings/google_analytics?value_only=false`);
    const data = await response.json();
    return data.data.value.trim();
  } catch (e) {
    return process.env.VUE_APP_GOOGLE_ANALYTICS;
  }
}
(async () => {
  //https://github.com/BuilderIO/partytown
  //https://analytics.google.com/analytics/web/#/a231951573w319349994p269217251/admin/tracking/tracking-code/
  //https://developers.google.com/analytics/devguides/collection/gtagjs/exceptions
  //https://matteo-gabriele.gitbook.io/vue-gtag/v/master/
  //https://developers.google.com/analytics/devguides/collection/ga4/reference/events#sign_up
  const ga4_id = await getSettingsGoogleAnalytics();
  if (ga4_id) {
    Vue.use(
      VueGtag,
      {
        appName: 'GIS BOX',
        config: {
          id: ga4_id,
          debug_mode: process.env.NODE_ENV !== 'production',
        },
        params: {
          send_page_view: false,
          page_title: 'GIS BOX',
        },
        pageTrackerEnabled: true,
        pageTrackerScreenviewEnabled: true,
        pageTrackerTemplate(to) {
          return {
            page_title: document.title,
            page_path: to.path,
          };
        },
        deferScriptLoad: true,
      },
      router
    );
  }
})();

export default window.vm = new Vue({
  name: 'main',
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
